import { Link } from 'react-router';
import { Sida } from '../layout/Sida.js';

export function SidanFinnsInte() {
  return (
    <Sida titel="Sidan finns inte">
      <p className="ingress">
        Länken stämmer inte. <Link to="/">Gå till inkorgen</Link>
      </p>
    </Sida>
  );
}
